"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Creatable = Creatable;
exports.parseOptionsFromClipboardEvent = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _creatable = _interopRequireDefault(require("react-select/creatable"));
var _SortableMultiSelectInput = _interopRequireDefault(require("./SortableMultiSelectInput"));
var _excluded = ["inputRef"];
/*:: // 

import { type ElementRef } from 'react';*/
/*:: import { type MultiSelectInputProps } from './MultiSelectInput';*/
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var NEWLINE_REGEX = /\r?\n/;
var valueFromRef = function valueFromRef(ref /*: ElementRef<*>*/) /*: Array<any>*/{
  var rawValue = ref.current.state.value;
  return rawValue ? Array.isArray(rawValue) ? rawValue : [rawValue] : [];
};
/*:: export type OptionType = { [string]: any };*/
/*:: export type OptionsType = Array<OptionType>;*/
var parseOptionsFromClipboardEvent = exports.parseOptionsFromClipboardEvent = function parseOptionsFromClipboardEvent(event /*: SyntheticClipboardEvent<HTMLElement>*/) /*: OptionsType*/{
  var clipboardValues = event.clipboardData.getData('Text');
  if (!clipboardValues) {
    return [];
  }
  return clipboardValues.split(NEWLINE_REGEX).reduce(function (unique, item) {
    var trimmed = item.trim();
    return unique.indexOf(trimmed) !== -1 ? unique : [].concat((0, _toConsumableArray2.default)(unique), [trimmed]);
  }, []).map(function (value) {
    return {
      label: value,
      value: value,
      __isNew__: true
    };
  });
};
/*:: export type CreatableType = {
  ...MultiSelectInputProps,
  inputRef?: ElementRef<*>
};*/
function Creatable(_ref /*:: */) {
  var ref = _ref /*:: */.inputRef,
    props = (0, _objectWithoutProperties2.default)(_ref /*:: */, _excluded);
  var inputRef = ref || (0, _react.createRef)();
  return /*#__PURE__*/_react.default.createElement(_SortableMultiSelectInput.default, (0, _extends2.default)({
    defaultValue: props.value,
    component: _creatable.default,
    inputRef: inputRef,
    onInputChange: function onInputChange(newValue, _ref2) {
      var action = _ref2.action;
      // When leaving the field, and the user entered a new item in a
      // creatable, select that new option.
      if (inputRef.current != null && action === 'input-blur') {
        var _select$state;
        // $FlowIgnore
        var select = inputRef.current.select;
        var newOption = select === null || select === void 0 ? void 0 : (_select$state = select.state) === null || _select$state === void 0 ? void 0 : _select$state.newOption;
        if (newOption) {
          select.select.selectOption(newOption);
        }
      }
    },
    onPaste: function onPaste(event) {
      // This lets us pull in a list of newline-delimited options from the
      // user's clipboard.
      if (inputRef.current != null && props.isMulti) {
        // $FlowIgnore
        var select = inputRef.current.select;
        event.preventDefault();
        var defaultValue = valueFromRef(inputRef);
        var isValidNewOption = select.props.isValidNewOption;
        var options = select.props.options || [];
        var newOptions = parseOptionsFromClipboardEvent(event).filter(function (_ref3) {
          var value = _ref3.value;
          return isValidNewOption(value, defaultValue, options);
        });
        if (newOptions.length > 0) {
          var mergedValues = [].concat((0, _toConsumableArray2.default)(defaultValue), (0, _toConsumableArray2.default)(newOptions));
          select.select.setValue(mergedValues);
        }
      }
    }
  }, props));
}
Creatable.displayName = 'Creatable';
var _default = exports.default = Creatable;
//# sourceMappingURL=Creatable.js.map